/**
 * Relationship Types and Directions
 * Centralized definitions for character relationships
 */

// Relationship types
export const RELATIONSHIP_TYPES = [
  { id: 'mentor', label: 'Mentor', color: '#1E7A4B' },
  { id: 'student', label: 'Student', color: '#4B9C3A' },
  { id: 'companion', label: 'Companion', color: '#3A7A9C' },
  { id: 'lover', label: 'Lover', color: '#9C3A4A' },
  { id: 'rival', label: 'Rival', color: '#7A4B1E' },
  { id: 'parent', label: 'Parent', color: '#6E2EBF' },
  { id: 'child', label: 'Child', color: '#8A4DFF' },
  { id: 'master', label: 'Master / Mistress', color: '#4B1F7A' },
  { id: 'patron', label: 'Patron', color: '#B8860B' },
  { id: 'agent', label: 'Agent', color: '#DAA520' },
  { id: 'creator', label: 'Creator', color: '#7A1E7A' },
  { id: 'creation', label: 'Creation', color: '#9C7A3A' },
  { id: 'self', label: 'Self / Secret Identity', color: '#C9C6CF' },
]

// Direction types
export const DIRECTIONS = [
  { id: 'to', label: '→ To them', symbol: '→', description: 'I feel this toward them' },
  { id: 'from', label: '← From them', symbol: '←', description: 'They feel this toward me' },
  { id: 'mutual', label: '↔ Mutual', symbol: '↔', description: 'Both directions equally' },
  { id: 'self', label: '⟳ Self', symbol: '⟳', description: 'Self-referential (alter-ego, past self)' },
]

// Helper functions
export function getRelationshipType(id) {
  return RELATIONSHIP_TYPES.find(t => t.id === id)
}

export function getDirection(id) {
  return DIRECTIONS.find(d => d.id === id)
}

export function getDirectionSymbol(id) {
  const direction = getDirection(id)
  return direction?.symbol || '?'
}

export function getRelationshipColor(typeId) {
  const type = getRelationshipType(typeId)
  return type?.color || '#9A96A3'
}
